class ViewMediaModalController {
    constructor(SettingsService, DownloadXmlExService, UserDetails) {
        this.$onInit = () => {
            // Initialise so we do load if its not xml
            this.showSpinnerBits = 2;
            this.init();
            if (this.media.ContentSubType !== 'image' && this.media.Type !== 'Collis') {
                this.traceReq = {
                    Take: 25,
                    UserId: -1,
                    SimId: -1,
                    TestSuiteId: -1
                };
                this.isMediaOverMaxLen = false;
                this.showSpinnerBits = 0;
                this.UserDetails.get().then((response) => {
                    this.showSpinnerBits++;
                    this.traceReq.ConnectedUser = response;
                });
                this.SettingsService.getSettings().then((response) => {
                    this.showSpinnerBits++;
                    let appSettings = response.data;
                    this.maxMediaLen = appSettings.TraceDownloadMaxKb;
                    // if the media is xml
                    let mediaLen = this.media.Content.length;
                    // now we have the number of bytes lets calculate
                    let mediaLenKb = mediaLen / 1024;
                    if (mediaLenKb > this.maxMediaLen) {
                        this.isMediaOverMaxLen = true;
                    }
                });
            }
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.init = () => {
            let params = this.resolve;
            this.media = params.media;
        };
        this.download = () => {
            if (this.media.TraceUid !== '') {
                this.traceReq.TraceId = parseInt(this.media.TraceUid);
            }
            this.DownloadServiceEx.downloadXml(this.traceReq);
        };
        this.SettingsService = SettingsService;
        this.DownloadServiceEx = DownloadXmlExService;
        this.UserDetails = UserDetails;
    }
}
angular.module('app').component('viewMediaModalComponent', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/ViewMedia/view-media-modal.tpl.html',
    controllerAs: 'vm',
    controller: ViewMediaModalController,
});
